import React, { useState } from 'react';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectInput,
} from 'candy-commons-components';
import {
    BooleanInput,
    Edit,
    required,
    SaveButton,
    SimpleForm,
    NumberInput,
    Toolbar,
    useTranslate,
    useDelete,
    useNotify,
    useRedirect,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DeleteIcon from '@material-ui/icons/Delete';
import SECTION_CHOICES from '../../data/ecommerceHomeSectionChoices.json';

const useToolbarStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
});

const DeleteWithConfirmButton = ({ record, resource }) => {
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();
    const [deleteOne, { loading }] = useDelete(
        resource,
        record && record.id,
        record,
        {
            onSuccess: () => {
                notify('Section deleted', 'info');
                redirect('list', `/${resource}`);
            },
            onFailure: (error) => {
                notify(`Error: ${error.message}`, 'warning');
            },
        }
    );

    return (
        <>
            <Button
                variant="contained"
                color="secondary"
                startIcon={<DeleteIcon />}
                onClick={() => setOpen(true)}
                style={{ marginLeft: '8px' }}
            >
                Delete
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Delete section</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the section{' '}
                        <strong>{record && record.section}</strong>? This action
                        cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setOpen(false)}
                        color="primary"
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={deleteOne}
                        color="secondary"
                        disabled={loading}
                        autoFocus
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const HomeSectionCmsToolbar = ({ permissions, resource, record, ...props }) => (
    <Toolbar {...props} classes={useToolbarStyles()}>
        <SaveButton />
        <span style={{ flex: '1' }} />
        {permissions &&
            permissions[resource] &&
            permissions[resource].delete && (
                <DeleteWithConfirmButton record={record} resource={resource} />
            )}
    </Toolbar>
);

const HomeSectionCmsEdit = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.ecommerce-home-sections.name'),
            url: 'ecommerce-home-sections',
            icon: <ViewModuleIcon />,
        },
        {
            text: translation('resources.ecommerce-home-sections.edit.name'),
            url: '',
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit {...props}>
                <SimpleForm
                    toolbar={
                        <HomeSectionCmsToolbar
                            permissions={permissions}
                            resource={props.resource}
                        />
                    }
                >
                    <ContainerFieldsList>
                        <CustomSelectInput
                            source="section"
                            choices={SECTION_CHOICES}
                            validate={[required()]}
                            label="Section"
                            disabled
                            helperText="Banner 1/2 are legacy (all brands). Use Banner 1/2 {Brand} so the slot appears only for the brand selected by the user."
                        />
                        <NumberInput
                            source="order"
                            label="Order"
                            validate={[required()]}
                            min={0}
                            max={999}
                        />
                        <BooleanInput source="active" label="Active" />
                    </ContainerFieldsList>
                </SimpleForm>
            </Edit>
        </>
    );
};

export default HomeSectionCmsEdit;
